module.exports = __webpack_public_path__ + "e12.no2.b21fbfbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/e12.no2.jpg
// module id = WLrS
// module chunks = 0